import type { GridRow, TableRow } from "./types";

const numberFormat = new Intl.NumberFormat("ru-RU", {
  maximumFractionDigits: 0,
});

export const formatPrice = (value: number | null) => (value === null ? "—" : numberFormat.format(value));

export const getPriceAlpha = (value: number | null, min: number, max: number) => {
  if (value === null || Number.isNaN(value)) return 0.08;
  if (max <= min) return 0.18;
  const ratio = (value - min) / (max - min);
  return Number((0.08 + ratio * 0.24).toFixed(3));
};

export const toRows = (rows: TableRow[], offset = 0): GridRow[] =>
  rows.map((row, index) => ({ id: offset + index + 1, ...row }));

export const parseDate = (value: string) => {
  const [day, month, year] = value.split(".").map((chunk) => Number(chunk));
  if (!day || !month || !year) return 0;
  return new Date(year, month - 1, day).getTime();
};

export const getComparableValue = (row: GridRow, field: string) => {
  if (field === "date") return parseDate(row.date);
  const value = row[field as keyof GridRow];
  if (value === null || value === undefined) return null;
  return value;
};
